import { globalNavigationSlice } from './global-navigation';
export const globalNavigationActions = globalNavigationSlice.actions;

export const { reducer: globalNavigationReducer } = globalNavigationSlice;
export * from './types';
